import React, { useEffect, useRef, useState } from "react";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Alert, Box, Button, Card, CardContent, CircularProgress, Container, Typography } from "@mui/material";

export default function VerifyEmailPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");
  const requestedRef = useRef(false);

  useEffect(() => {
    const token = searchParams.get("token");
    if (requestedRef.current) return;
    requestedRef.current = true;

    if (!token) {
      setStatus("error");
      setMessage(t("verifyEmail.missingToken"));
      return;
    }

    fetch(`${process.env.REACT_APP_BASE_URL}/auth/verify-email`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    })
      .then(async (response) => {
        const json = await response.json().catch(() => null);
        if (!response.ok) {
          throw new Error(json?.message || t("verifyEmail.error"));
        }
        setStatus("success");
      })
      .catch((e) => {
        setStatus("error");
        setMessage(e?.message || String(e));
      });
  }, [searchParams, t]);

  return (
    <Container maxWidth="sm" sx={{ pt: 14, pb: 8 }}>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h4" component="h1" sx={{ mb: 3, fontWeight: 700 }}>
            {t("verifyEmail.title")}
          </Typography>

          {status === "loading" ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CircularProgress size={20} />
              <Typography>{t("verifyEmail.loading")}</Typography>
            </Box>
          ) : null}

          {status === "success" ? (
            <Alert severity="success" sx={{ mb: 2 }}>
              {t("verifyEmail.success")}
            </Alert>
          ) : null}

          {status === "error" ? (
            <Alert severity="error" sx={{ mb: 2 }}>
              {message || t("verifyEmail.error")}
            </Alert>
          ) : null}

          <Button component={RouterLink} to="/SignInPage" variant="contained">
            {t("verifyEmail.goLogin")}
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
}
